import SetUserAppRoleRequestModelBase from '../_generated/modelBases/set-user-app-role-request-model-base';

export default class SetUserAppRoleRequestModel extends SetUserAppRoleRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
